import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const MissionProcessingPage = () => {
  return (
    <HomeUI />
  )
}

export default MissionProcessingPage;
